export default function isChild(target, test) {
  if (typeof test == "string") {
    return !!target.closest(test);
  }
  return test.contains(target);
}
